export default class ThemedicUpdateService {
  getAll() {
    return fetch("https://api.tradersr.com/api/themedicupdate")
      .then(res => res.json());
  }
}